import React from "react";
import "./SearchInput.css";

const SearchInput = ({
  value,
  onChange,
  placeholder = "Search",
  className = "",
  icon = true,
}) => {
  return (
    <div className={`global-search-input ${className}`}>
      {icon && (
        <span className="search-input-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M16.3099 15.561L20.4239 19.676L19.5759 20.524L15.4529 16.401C14.0607 17.549 12.2789 18.1151 10.4793 17.981C8.67978 17.8469 7.00154 17.023 5.79484 15.6813C4.58814 14.3396 3.9462 12.5837 4.00298 10.78C4.05977 8.97641 4.81089 7.26439 6.0996 6.00124C7.38831 4.73809 9.11504 4.02142 10.9195 4.00078C12.7239 3.98014 14.4665 4.65713 15.7838 5.89047C17.1011 7.12381 17.8912 8.81821 17.9892 10.6201C18.0872 12.4219 17.4856 14.192 16.3099 15.561ZM16.7999 11C16.7999 9.46175 16.1888 7.9865 15.1011 6.89878C14.0134 5.81107 12.5382 5.2 10.9999 5.2C9.46164 5.2 7.98639 5.81107 6.89868 6.89878C5.81097 7.9865 5.1999 9.46175 5.1999 11C5.1999 12.5383 5.81097 14.0135 6.89868 15.1012C7.98639 16.1889 9.46164 16.8 10.9999 16.8C12.5382 16.8 14.0134 16.1889 15.1011 15.1012C16.1888 14.0135 16.7999 12.5383 16.7999 11Z"
              fill="#27346A"
            />
          </svg>
        </span>
      )}
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="search-input-field"
      />
    </div>
  );
};

export default SearchInput;
